/**
 * Group codes that may render this-side `mappings_data` on a primary hub store.
 * Other groups rely on the opposite-channel (primary) mapping path instead.
 */
export const PRIMARY_HUB_THIS_SIDE_MAPPING_GROUP_CODES = [
  'ACCOUNTING_ORDER',
  'ERP_ORDER',
  'OMS_ORDER',
  'SHIPMENT',
  'INVENTORY',
  'PRODUCT',
] as const

export type PrimaryHubThisSideMappingGroupCode =
  (typeof PRIMARY_HUB_THIS_SIDE_MAPPING_GROUP_CODES)[number]

export const shouldRenderThisSideMappingsOnPrimaryHub = (
  groupCode: string | undefined | null,
  isPrimaryHub: boolean,
  options?: {includeTicket?: boolean}
): boolean => {
  if (!isPrimaryHub) {
    return true
  }

  if (!groupCode) {
    return false
  }

  if (
    (PRIMARY_HUB_THIS_SIDE_MAPPING_GROUP_CODES as readonly string[]).includes(groupCode)
  ) {
    return true
  }

  if (options?.includeTicket && groupCode === 'TICKET') {
    return true
  }

  return false
}
